import { apiResponseTypeEnum } from '@/constants/api.js';

export const loginErrorMessagesPerResponseType = {
  [apiResponseTypeEnum.MSISDN_NOT_EXIST]: 'page_login_error_invalid_credentials',
  [apiResponseTypeEnum.SERVER_ERROR]: 'page_login_error_server_error',
};
